export const AutoWageMatrixRoutes = {
    "/wage-matrix/:brand_id/:rule_id?duplicate_id": {
        "loginRequired": true,
        "name": "appLayout.harriSH.wage-matrix",
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["auto_wage_matrix"]
        },
        "params": {
            "rule_id": {
                value: null,
            }
        },
        "component": 'manageWageRuleContainer',
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Wage Rule"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./auto-wage-matrix.module.js");
                }
            }
        ],
    },
}